import request from "@/utils/request";

// 疗效用户信息跟踪
export function getUserInfo(params) {
  return request({
    url: "/user-tracking/userMember/getPatientDetailsById",
    method: "get",
    params,
  });
}

// 疗效字典 标签字典
export function getDictionaryList(params) {
  return request({
    url: "/misc-service/typeInfo/detail",
    method: "get",
    params,
  });
}

// 删除其他标签
export function delectTag(id) {
  return request({
    url: `/user-service/manage/umt/delUserMemberTag/${id}`,
    method: "delete",
  });
}

// 添加其他标签

export function addTag(data) {
  return request({
    url: "/user-service/manage/umt/addUserMemberTag",
    method: "post",
    data,
  });
}

// 西医诊断
export function getWesternList(params) {
  return request({
    url: "/doctor-service/doctormg/prescription/icdSearch",
    method: "get",
    params,
  });
}

// 症状下拉的列表
export function getSymptomlist(params) {
  return request({
    url: "/doctor-service/symptom/symptomSelectItem",
    method: "get",
    params,
  });
}

// 获取患者疾病信息
export function getPatient(id) {
  return request({
    url: `/user-tracking/memberTreatment/getMemberIllnessSummary/${id}`,
    method: "get",
  });
}
// 添加患者疾病信息

export function addPatient(data) {
  return request({
    url: "/user-tracking/memberTreatment/addMemberDisease",
    method: "post",
    data,
  });
}

// 删除患者疾病信息
export function removePatient(id) {
  return request({
    url: `user-tracking/memberTreatment/delMemberDisease/${id}`,
    method: "delete",
  });
}

// 获取信息 1 瞑眩反应 2 入药反应 3 新发症状 4 停/续药安排
export function getTabData(data) {
  return request({
    url: "/user-tracking/memberTreatment/getSymptom",
    method: "post",
    data,
  });
}

// 查询患者冶疗疗程列表接口
export function getTherapeuticEvaluation(params) {
  return request({
    url: "/user-tracking/memberTreatment/getCourseRecord",
    method: "get",
    params,
  });
}

// 更新疗效评价
export function upDateTherapeuticEvaluation(data) {
  return request({
    url: "/user-tracking/memberTreatment/updateCourseAppraise",
    method: "post",
    data,
  });
}

// 新增患者病情治疗症状
export function addSymptomsOfIllness(data) {
  return request({
    url: "/user-tracking/memberTreatment/addSymptom",
    method: "post",
    data,
  });
}

// 修改患者病情治疗症状
export function updateSymptomsOfIllness(data) {
  return request({
    url: "/user-tracking/memberTreatment/updateSymptom",
    method: "post",
    data,
  });
}

// 删除患者病情治疗症状
export function removeSymptomsOfIllness(id) {
  return request({
    url: `/user-tracking/memberTreatment/delSymptom/${id}`,
    method: "delete",
  });
}

// 修改病情描述
export function changeDescription(data) {
  return request({
    url: "/user-service/member/modifyIllnessSyntheticDes",
    method: "post",
    data,
  });
}
